import { ILoadPayloadDTO } from '../dtos/load-payload-dto';
import { IContractManagementFilterRanges } from '@/contract-management/types/contract-management-filter-ranges';
import { ILoadPayload } from '@/contract-management/types/load-payload';
import { EnumDocumentType } from '@/enums/DocumentType';
import { ITag } from '@lib-shared/types/Tag';

export class ContractManagementAPIHelper {
  static verifyFilterRanges(
    filterRanges: IContractManagementFilterRanges
  ): IContractManagementFilterRanges {
    return {
      minValue: filterRanges.minValue,
      maxValue: filterRanges.maxValue,
      minContractLength: filterRanges.minContractLength,
      maxContractLength: filterRanges.maxContractLength,
    };
  }

  static createLoadPayloadDTO(payload: ILoadPayload): ILoadPayloadDTO {
    return {
      folderId: !payload.filter.filterOnAllDocuments ? payload.folderId : null,
      showInAllFolders: payload.filter.filterOnAllDocuments,
      search: payload.searchPhrases,
      offset: payload.offset,
      limit: payload.limit,
      tags: payload.filter.tags.map((tag: ITag) => tag.id),
      users: payload.filter.userIds,
      value: payload.filter.valueRange,
      contractLength: payload.filter.contractLengthRange,
      contractEndDate: payload.filter.contractEndDateRange,
      documentTypes: payload.filter.documentTypes.includes(EnumDocumentType.Other)
        ? [...payload.filter.documentTypes, EnumDocumentType.Document]
        : payload.filter.documentTypes,
      signDate: payload.filter.signDateRange,
      sortBy: payload.sortBy,
      sortOrder: payload.sortOrder,
    };
  }
}
